// src/Montaan/Tour/index.tsx

export { default } from './Tour';
